import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import TermsOfServiceHero from "./sections/TermsOfServiceHero";
import TermsSections from "./sections/TermsSections";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <TermsOfServiceHero />
      <TermsSections />
      <Footer />
    </div>;
}